import debounce from 'debounce-fn';

document.body.addEventListener('ebbotInit', function() {
	if(!document.querySelector(('.order-form'))) return;
	if(!window.Ebbot) return;

	window.Ebbot.onLoad = function(data) {
		window.Ebbot.hide();
	};

	window.Ebbot.onChatWindowClose = function() {
		window.Ebbot.hide();
	};
});

($ => {
	if(!$('.order-form').length) return;

	const rutReduction = parseInt(sessionStorage.getItem('rut_reduction') === null ? 1 : sessionStorage.getItem('rut_reduction'), 10);
	$('.mobile-rut-toggler').prop('checked', !!rutReduction);
	$('.rut-toggler').prop('checked', !!rutReduction);
	
	$('.validate-zipcode').on('click', function(e) {
		const btn = $(this);

		if(btn.is('[required]:placeholder-shown ~ button')) {
			return e.preventDefault();
		}
	});

	$('[name="promotion_code"]').on('focus', function() {
		const field = $(this).closest('.field');
		field.removeClass('invalid');
	}).on('blur', function() {
		const input = $(this);

		getCampaign(input);
	}).on('input', function() {
		const input = $(this);
		
		getCampaign(input, true);
	}).trigger('input');

	function getCampaign(input, ignoreError = false) {
		const field = input.closest('.field');
		const value = $.trim(input.val());
		const notices = field.closest('form').find('.notices');
		const sidebarCampaign = $('.order-sidebar .sidebar-campaign');

		if(ignoreError) {
			field.removeClass('invalid valid');
		}
		
		if(!value) return;

		$.ajax({
			dataType: 'json',
			url: `/eriks-ajax/order/campaign/${value}?service=${window.orderData.service}`,
			success(response) {
				window.orderData.campaign = response;
				field.removeClass('invalid').addClass('valid');
				updateSidebar();
			},
			
			error() {
				window.orderData.campaign = null;
				if(!ignoreError) {
					field.removeClass('valid').addClass('invalid');
				}

				updateSidebar();
			}
		});
	}

	$('.info').on('click', function(e) {
		e.stopPropagation();
		const modal = $(this).closest('.modal-origin').find('.order-modal');
		modal.addClass("open");
	});

	$('.order-modal').on('click', function(e) {
		e.stopPropagation();

		if(e.target === this) {
			const modal = $(this).closest('.modal-origin').find('.order-modal');
			modal.removeClass("open");
		}
	});

	$('.order-modal .close').on('click', function(e) {
		const modal = $(this).closest('.modal-origin').find('.order-modal');
		modal.removeClass("open");
	});

	$('.mobile-rut-toggler').on('change', function(e) {
		e.stopPropagation();
		$('input[name="rut_reduction"]').prop('checked', $(this).prop('checked')).trigger('change');
	});

	$('.rut-toggler').on('change', function(e) {
		$('.mobile-rut-toggler').prop('checked', $(this).prop('checked'));
		sessionStorage.setItem("rut_reduction", $(this).is(":checked") ? 1 : 0);
	});

	$('.order-wrapper').on('change', updateSidebar).trigger('change');
	
	function updateSidebar() {
		if(!window.orderData) return;

		const serviceEl = $('input[name="service"]:checked');
		const rutReductionEl = $('input[name="rut_reduction"]');
		const sidebar = $('.order-sidebar');

		const services = window.orderData.services;
		const campaign = window.orderData?.campaign || null;
		const reduced_price = window.orderData?.reduced_price || null;
		const full_price = window.orderData?.full_price || null;
		const half_time = window.orderData?.half_time || null;
		const full_time = window.orderData?.full_time || null;
		
		const serviceId = (serviceEl.length ? serviceEl.val() : (window.orderData.service || 0));
		const service = services[serviceId];
		
		if(reduced_price && full_price) {
			const price = rutReductionEl.prop('checked') ? reduced_price : full_price;
			
			sidebar.find('.price-text').text('Cirkapris');
			sidebar.find('.total-price').html(`${price} kr`);

			$('.sidebar-campaign').slideUp(150);
		} else if(campaign && service.campaignable && (!campaign.services || campaign.services.length === 0 || campaign.services.includes(service.id))) {
			const price = rutReductionEl.prop('checked') ? campaign.price : campaign.full_price;
			
			sidebar.find('.price-text').text(campaign.pre_price || 'Fast pris');
			sidebar.find('.total-price').html(`${price} kr`);

			$('.campaign-tag').text(campaign.code);
			$('.campaign-description').text(campaign.description);
			$('.sidebar-campaign').slideDown(150);
		} else {
			const priceRatio = (rutReductionEl.prop('checked') ? 1 : 2);

			sidebar.find('.price-text').text('Ungefärligt pris');
			sidebar.find('.total-price').html(`${service.price_from * priceRatio} &ndash; ${service.price_to * priceRatio} kr`);

			$('.sidebar-campaign').slideUp(150);
		}

		if(half_time && full_time) {
			sidebar.find('.sidebar-time-estimate').html(`
				<div>Beräknad tid, 1 putsare: ${full_time}</div>
				<div>Beräknad tid, 2 putsare: ${half_time}</div>
			`);
		} else {
			sidebar.find('.sidebar-time-estimate').html(sidebar.find('.sidebar-time-estimate').data('original'));
		}

		if(service.notice && service.notice.length) {
			$('.service-warning-dialog .content').text(service.notice);
			$('.step-1 > form footer button[type="submit"]').addClass('warn');
		} else {
			$('.service-warning-dialog .content').text('');
			$('.step-1 > form footer button[type="submit"]').removeClass('warn');
		}		

		$('.order-sidebar-service').html(`<img src="${service.icon_url}" alt="${service.display_name}" />${service.display_name}`);
	}

	$('.service-warning-dialog button[type="button"]').on('click', () => {
		document.querySelector('.service-warning-dialog').close();
	});

	$('.step-1 > form').on('click', 'footer button.warn', (e) => {
		e.preventDefault();
		document.querySelector('.service-warning-dialog').showModal();
	});

	$('.order-sidebar .sidebar-campaign .read-more').on('click', function(e) {
		const p = $(this).closest('.sidebar-campaign').find('.campaign-description-wrapper');
		p.toggleClass('short');

		let text = $(this).text() == 'Visa mindre' ? 'Läs mer' : 'Visa mindre';

		$(this).text(text);
	});

	$('.order-sidebar .toggle-sidebar').on('click', function(e) {
		e.preventDefault();
		$(this).closest('.sidebar-wrapper').toggleClass('sidebar-open');
	});

	$('.overlay').on('click', function(e) {
		e.stopPropagation();

		if(e.target === this) {
			const sidebar = $(this).closest('.sidebar-wrapper');
			sidebar.removeClass("sidebar-open");
		}
	});

	const onFormInput = debounce((form) =>  $.post({
		url: `/eriks-ajax/order/calculate-price`,
		data: form.serialize(),
		success(response) {
			window.orderData.reduced_price = response.reduced_price;
			window.orderData.full_price = response.full_price;
			window.orderData.half_time = response.half_time;
			window.orderData.full_time = response.full_time;
			updateSidebar();
		},
		error() {
			window.orderData.reduced_price = null;
			window.orderData.full_price = null;
			window.orderData.half_time = null;
			window.orderData.full_time = null;
			updateSidebar();
		}
	}), { wait: 300 });

	$(document.body).on('click', '.vents .quantity-button', function() {
		const input = $(this).siblings('input');

		if($(this).hasClass('plus')) {
			input.val((_, oldval) => parseInt(oldval, 10) + 1);
			input.trigger('input');
		}

		else if($(this).hasClass('minus') && input.val() > 0) {
			input.val((_, oldval) => parseInt(oldval, 10) - 1);
			input.trigger('input');
		}
	});

	$(document.body).on('input', '.window-option-floors input, .window-option-floors select', function() {
		onFormInput($(this).closest('form'));
	});

	const addFloor = (label, first) => {
		const floors = $('.window-option-floors > ul > li').length;
		const floorTemplate = document.querySelector('.window-option-floors template');
		const floorClone = floorTemplate.content.cloneNode(true);
		
		$(floorClone).find('summary label span').text(label);
		$(floorClone).find('.floor-label').val(label);
		$(floorClone).find('input, select, label').each((i, input) => {
			let name = $(input).attr('name');
			let id = $(input).attr('id');
			let forAttr = $(input).attr('for');

			if(name) {
				name = name.replace('{floor}', floors);
				$(input).attr('name', name);
			}

			if(id) {
				id = id.replace('{floor}', floors);
				$(input).attr('id', id);
			}

			if(forAttr) {
				forAttr = forAttr.replace('{floor}', floors);
				$(input).attr('for', forAttr);
			}
		});

		$('.window-option-floors > ul').append(floorClone);
		$('.window-option-floors > ul > li:last-of-type').attr('data-floor', label);

		requestAnimationFrame(() => {
			if(first) {
				$('.window-option-floors > ul > li:last-child').css('order', -1);
			}
		})

		addWindowGroup(floors);
	};

	const addWindowGroup = (floorIndex, data) => {
		const floor = $('.window-option-floors > ul > li').get(floorIndex);
		const nextGroup = $(floor).find('.window-option-floor ol > li[data-group]').get().reduce((acc, cur) => Math.max(acc, parseInt(cur.dataset.group)), -1) + 1;
		const windowGroupTemplate = floor.querySelector('.window-option-floor template');
		const windowGroupClone = windowGroupTemplate.content.cloneNode(true);
		
		$(windowGroupClone).find('[data-group]').attr('data-group', nextGroup);
		$(windowGroupClone).find('input, select, label').each((i, input) => {
			let name = $(input).attr('name');
			let id = $(input).attr('id');
			let forAttr = $(input).attr('for');

			if(name) {
				name = name.replace('{floor}', floorIndex).replace('{group}', nextGroup);
				$(input).attr('name', name);
			}

			if(id) {
				id = id.replace('{floor}', floorIndex).replace('{group}', nextGroup);
				$(input).attr('id', id);
			}

			if(forAttr) {
				forAttr = forAttr.replace('{floor}', floorIndex).replace('{group}', nextGroup);
				$(input).attr('for', forAttr);
			}
		});

		$(floor).find('.window-option-floor ol').append(windowGroupClone);

		if ($(floor).data('floor') === 'Källarvåning') {
			$(floor).find('.window-group:last-child').remove();
		}
	};

	const removeFloor = (label) => {
		const floor = $(`.window-option-floors > ul > li[data-floor="${label}"]`);
		
		if(floor) {
			floor.remove();
		}
	};

	const setFloors = () => {
		const houseType = $('select[name="windows[house_type]"]').val();

		if(!houseType) return;

		$('.window-option-floors > ul > li').remove();
		$('.window-option-floors').show();
		$('.window-description').hide();

		switch(houseType) {
			case 'apartment':
				$('.window-options.basement').hide();
				$('[name="windows[basement]"][value="Nej"]').prop('checked', true);
				addFloor('Lägenhet');
				break;
			case 'one-floor':
				$('.window-options.basement').show();
				addFloor('Bottenvåning');
				break;
			case 'half-floor':
			case 'two-floor':
			case 'split-level':
				$('.window-options.basement').show();
				addFloor('Bottenvåning');
				addFloor('Övervåning');
				break;
			case 'other':
				$('.window-options.basement').hide();
				$('.window-option-floors').hide();
				$('.window-description').show();
				break;
		}

		// addFloor('Övriga utrymmen');

		if($('[name="windows[basement]"]:checked').val() === 'Ja') {			
			addFloor('Källarvåning', true);
		}
	}

	const setGroups = () => {
		if (!window.orderData.house || !window.orderData.house.floors) return;

		$('.window-options.vents li[data-group]').remove();

		for(const index in window.orderData.house.floors) {
			const floor = window.orderData.house.floors[index];
			
			if(floor.groups.length) {
				for(const group of floor.groups) {
					addWindowGroup(index, group);
				}
			} else {
				addWindowGroup(index);
			}
		}
	}

	$(document).on('ready', () => {
		if($('.order-wrapper.step-5').length && window.orderData) {
			const reduced_price = window.orderData?.reduced_price || null;
			const full_price = window.orderData?.full_price || null;
			
			if(reduced_price && full_price) {
				$('.order-wrapper.step-5').find('.price-text').text('Cirkapris:');
				$('.order-wrapper.step-5').find('.total-price').html(`${reduced_price} med RUT (annars ${full_price})`);
			}
		} else {
			setFloors();
			setGroups();
		}
		
		if($('select[name="windows[house_type]"]').length) {
			$('select[name="windows[house_type]"]').select2({
				minimumResultsForSearch: Infinity
			});
		}

		const requestedWeek = $('select[name="windows[requested_week][]"]');

		if(requestedWeek.length) {
			requestedWeek.select2({
				placeholder: 'Lämna tomt för putsning så snart som möjligt'
			});
		}
	});

	$(document.body).on('input', 'select[name="windows[house_type]"]', setFloors);

	$(document.body).on('input', '[name="windows[basement]"]', function() {
		if($(this).val() === 'Ja') {
			addFloor('Källarvåning', true);
		} else {
			removeFloor('Källarvåning');
		}
	});

	$(document.body).on('input', '[name="windows[description]"]', function() {
		$('.window-option-floors ~ footer button').prop('disabled', !$(this).val());
	});

	const checkQuantity = function() {
		const hasQuantity = $('.options .quantity input[type="number"]').get().some(n => {
			if (n.value < 1) return false;
			if (!$(n).closest('.window-group').children('input[type="checkbox"]:checked').val()) return false;
			return true;
		});

		$('.window-option-floors ~ footer button').prop('disabled', !hasQuantity);
	}
	$(document.body).on('input', '.options .quantity input[type="number"]', checkQuantity);
	$(document.body).on('input', '.window-group > input[type="checkbox"]', checkQuantity);

	$(document.body).on('click', '.customer-data summary', function() {
		$('#customer_id').prop('disabled', !$(this).closest('details').get(0).open);
	});

	$(document.body).on('change', '.customer-data #ssn', function() {
		const nonce = $('#eriks_calculator_nonce').val();
		const ssn = $(this).val();

		if(!nonce || !ssn) return;

		$.get({
			url: `/eriks-ajax/order/lookup_ssn`,
			data: {
				ssn,
				nonce
			},
			success: (data) => {
				$('.customer-data #firstname').val(data.billing_firstname);
				$('.customer-data #lastname').val(data.billing_lastname);
				$('.customer-data #street-name').val(data.billing_street_name);
				$('.customer-data #street-number').val(data.billing_street_number);
				$('.customer-data #suffix').val(data.billing_street_suffix);
				$('.customer-data #zipcode').val(data.billing_zipcode);
				$('.customer-data #city').val(data.billing_city);
			}
		})
	});
})(jQuery);
